import { projectsApi } from '../common'
import { useQuery, UseQueryOptions } from 'react-query'
import { components } from '@plandi/common/src/generated'
import { AxiosError } from 'axios'
import { useLocale } from '@plandi/common'
export const useQueryProjectTags = (
  options?: UseQueryOptions<
    components['schemas']['ProjectTagListResource']['data'],
    AxiosError,
    components['schemas']['ProjectTagListResource']['data']
  >
) => {
  const locale = useLocale()
  const query = useQuery({
    queryKey: ['projectTags', locale],
    queryFn: () => projectsApi.getProjectTags(locale),
    ...options
  })
  return query
}
